import getSisoFilterAccess from '@hooks/siso/getSisoFilterAccess';

const useGetSisoFilterAccess = () => getSisoFilterAccess();

export default useGetSisoFilterAccess;
